import { BitfGraphQlApiCallStateMapper } from '@bitf/core/api-call-state/bitf-graph-ql-api-call-state';

export class DefaultApiCallStateMapper extends BitfGraphQlApiCallStateMapper {}
